import "./SwapModal.css";

export default function PlayerSwapModal({
  slot,
  players,
  draftLineup,
  onSwap,
  onSave,
  onCancel,
}) {
  const currentPlayer = draftLineup[slot];

  return (
    <div className="pitch-modal-backdrop" onClick={onCancel}>
      <div
        className="pitch-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>Swap player for {slot}</h3>
        </div>

        <ul className="modal-list">
          {players.map((p) => {
            const isCurrent = currentPlayer?.id === p.id;

            return (
              <li
                key={p.id}
                className={`swap-item ${isCurrent ? "disabled" : ""}`}
                onClick={() => !isCurrent && onSwap(slot, p)}
              >
                <span>
                  <strong>{p.shirtNumber}</strong> {p.name}
                </span>
                <span className="swap-position">
                  #{p.formationPlace}
                </span>
              </li>
            );
          })}
        </ul>

        <div className="modal-actions">
          <button onClick={onCancel}>Cancel</button>
          <button className="primary" onClick={onSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
